// constants
import { NAV_MENU, NavSubMenuItemWithAuthRoles } from '@/src/constants/navMenu';

// types
import { NavMenuItem, NavSubMenuItem } from '@/src/components/ui/organisms/Header/Header';
import type { User } from '@/src/types/User';
import { AuthRole } from '../constants/shared';
import { RoutePath } from '../RoutePath';

const getNavSubMenuForUser = (user: User | null, subMenuItems?: NavSubMenuItemWithAuthRoles[]): NavSubMenuItem[] => {
  if (!subMenuItems) return [];

  // remove submenuitems for which user doesn't have access
  const newItems = subMenuItems.filter((item) =>
    (user?.isAmazonian && item.href === RoutePath.CAMPAIGNS) ||
    item.roles.some((role) => (!user ? role === AuthRole.GUEST_USER : user.memberOfGroup(role)))
  );

  return newItems as NavSubMenuItem[];
};

export const getNavMenuForUser = (user: User | null): NavMenuItem[] => {
  return NAV_MENU.map((item) => ({ ...item, subMenuItems: getNavSubMenuForUser(user, item.subMenuItems) })).filter(
    (item) => {
      if (item.hasSubMenu) {
        return item.subMenuItems.length > 0;
      }
      if (!user && item.href === RoutePath.ADMIN) {
        return false;
      }
      if (user && !user.memberOfGroup(AuthRole.JAM_ADMIN) && item.href === RoutePath.ADMIN) {
        return false;
      } else {
        return true;
      }
    }
  ); // remove empty submenuitems
};
